// extracted by css-extract-rspack-plugin
export default {"search_form_input":"byqss","searchFormInput":"byqss","icon":"d_udQ","input":"JcvZ_","short":"lecjY"};